module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/shanti-ekambaram.json
// module id = 690
// module chunks = 158943685967084